import { createI18n } from 'vue-i18n';

const messages = {};

const i18n = createI18n({
	legacy: false,
	locale: 'en',
	fallbackLocale: 'en',
	messages,
});

i18n.t = (...args) => i18n.global.t(...args);
i18n.te = (...args) => i18n.global.te(...args);

export default i18n;
